import React, {Component} from 'react';
import Errors from '../common/Errors'
import {Link} from "react-router-dom";
import SimpleReactValidator from 'simple-react-validator';
import InvalidAccessOrLogin from '../errorsPage/InvalidAccessOrLogin';
import * as AppConstant from '../common/AppConstant'
import * as Util from '../common/Util';
import {Redirect} from 'react-router-dom';
import RequiredAstrisk from '../common/RequiredAstrisk'

class EmailConf extends Component {

    constructor(props) {
        super(props);
        this.state = {
            status: '',
            id: null,
            emailConfiguration: {

            },
            loggedInUser:{},
            disabledButton: false,
            usernameError : null,
            passwordError : null,
            confirmPasswordError : null,
            fromNameError : null,
            serverError : null,
            portError : null,
            propertiesError : null,
            redirectToDashBoard:false,
            redirectToErrorPage:false,
            redirectToForbiddenPage: false,
            apiStatus: {
                isError: false,
                message: '',
                messages: []
            },
            errorMessage: '',
            showLoader:false
        };
        this.fetchEmailConf = this.fetchEmailConf.bind(this);
        this.checkBoxChange = this.checkBoxChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.sendTestEmail = this.sendTestEmail.bind(this);
        this.getformData = this.getformData.bind(this);
        this.fetchLoggedInStaff = this.fetchLoggedInStaff.bind(this);
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            element: false
        });
    }
    componentDidMount(){
        this.fetchLoggedInStaff()
    }
    fetchLoggedInStaff(){
        let _this = this;
        fetch(this.props.api + '/staff/currentUser', {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    _this.props.onLogoutClick(json.message);
                }else{
                    if(json && json.staff && json.staff.userRoles.some(v => (v === "ROLE_ADMIN" || v === "ROLE_SYSTEM_SUPPORT" || v === "ROLE_MANAGER"))){
                        _this.setState({loggedInUser: json.staff}, function(){
                            _this.fetchEmailConf();
                        })
                    }else{
                        this.setState({redirectToErrorPage:true})
                    }
                }
                _this.setState({showLoader:false});
            }).catch(error => {
            console.log(error)
        });
    }
    fetchEmailConf() {
        this.setState({showLoader:true});
        fetch(this.props.api + '/emailConfiguration', {
            method: "GET",
            mode: 'cors',
            headers: {
                "X-AUTH-TOKEN": this.props.jwtToken,
                'content-type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.isError === false){
                    let emailConf = json.emailConfiguration;
                    emailConf["confirm"] = emailConf.password;
                    this.setState({emailConfiguration: emailConf});
                    this.setState({showLoader: false})
                }else{
                    console.log(json);
                    this.setState({showLoader: false});
                    if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                        this.props.onLogoutClick(json.message);
                    } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                        this.setState({redirectToForbiddenPage: true});
                    }
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({showLoader:false});
            });
    }
    handleChange(event) {
        const {emailConfiguration} = this.state;
        const target = event.target;
        const name = target.name;
        const value = target.value;
        emailConfiguration[name] = value;
        this.setState({emailConfiguration: emailConfiguration});
    }
    checkBoxChange(value, name) {
        if (value === true) {
            const {emailConfiguration} = this.state;
            emailConfiguration[name] = false;
            this.setState({emailConfiguration: emailConfiguration});
        } else {
            const {emailConfiguration} = this.state;
            emailConfiguration[name] = true;
            this.setState({emailConfiguration: emailConfiguration});
        }
    }

    getformData(url){
        console.log(this.validator.allValid());
        const {apiStatus}  = this.state;
        if (this.validator.allValid()) {
            this.setState({showLoader:true});
            fetch(this.props.api + url, {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(this.state.emailConfiguration),
                headers: {
                    'X-AUTH-TOKEN': this.props.jwtToken,
                    'content-type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(json => {
                    if (json && json.isError === false) {
                        Util.successResponse(apiStatus, json);
                        this.setState({disabledButton: false, apiStatus: apiStatus,showLoader:false, redirectToDashBoard:(apiStatus.isError === false ? true : false)});
                    } else {
                        Util.errorResponse(apiStatus, json);
                        this.setState({disabledButton: false, apiStatus: apiStatus, showLoader: false});
                        if (json && json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                            this.props.onLogoutClick(json.message);
                        } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                            this.setState({redirectToForbiddenPage: true});
                        }
                    }
                })
                .catch(error => {
                    Util.errorCatchResponse(apiStatus, error);
                    this.setState({disabledButton: false, apiStatus: apiStatus, showLoader:false});
                });
        }
        else{
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    sendTestEmail() {
        console.log(this.validator.allValid());
        const {apiStatus}  = this.state;
        if (this.validator.allValid()) {
            this.setState({showLoader: true});
            fetch(this.props.api + "/emailConfiguration/checkEmail", {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(this.state.emailConfiguration),
                headers: {
                    'X-AUTH-TOKEN': this.props.jwtToken,
                    'content-type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(json => {
                    if (json && json.isError === false) {
                        Util.successResponse(apiStatus, json);
                        this.setState({disabledButton: false, apiStatus: apiStatus,showLoader: false});
                    } else {
                        Util.errorResponse(apiStatus, json);
                        this.setState({disabledButton: false, apiStatus: apiStatus, showLoader: false});
                        if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                            this.props.onLogoutClick(json.message);
                        } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                            this.setState({redirectToForbiddenPage: true});
                        }
                    }
                })
                .catch(error => {
                    Util.errorCatchResponse(apiStatus, error);
                    this.setState({disabledButton: false, apiStatus: apiStatus});
                    this.setState({showLoader: false})
                });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        this.getformData("/emailConfiguration")
    }

    render() {
        let _this = this;
        return (
            <div className="wrapper animated fadeInRight">
                <InvalidAccessOrLogin jwtToken={this.props.jwtToken}
                                      redirectToErrorPage={this.state.redirectToErrorPage}
                                      redirectToForbiddenPage={this.state.redirectToForbiddenPage}/>
                {
                    (this.state.redirectToDashBoard && this.state.apiStatus && this.state.apiStatus.message) ? (<Redirect to={'/msg/'+this.state.apiStatus.message}/>) : null
                }
                <div className="row">
                    <div className="col-lg-12">
                        <div className="dashboard-table-wrap">
                            <div className="heading-wrapper clearfix">
                                <p className="m-t-xs">{_this.props.msg('emailConfig.label.header')}</p>
                            </div>
                            <div className="table-box table-responsive p-m" style={{minHeight:'490px'}}>
                                <Errors errorObject={this.state.apiStatus}/>
                                {this.state.showLoader === true ? (<div className="loading">Loading&#8230;</div>) : ''}
                                <form onSubmit={this.handleSubmit} className="form-horizontal" autoComplete="off">
                                    <div className="col-md-12">
                                        <div className="col-md-6">
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('emailConfig.label.userName')}<RequiredAstrisk/></label>

                                                <div className="col-lg-7">
                                                    <input type="text" className="form-control" id="username"
                                                           name="username" onChange={this.handleChange}
                                                           value={this.state.emailConfiguration.username?this.state.emailConfiguration.username:''} maxLength="64"/>
                                                    <div style={{color:"red"}}>
                                                        {this.validator.message('username', this.state.emailConfiguration.username, 'required|max:64')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('emailConfig.label.password')}<RequiredAstrisk/></label>

                                                <div className="col-lg-7">
                                                    <input type="password" className="form-control" id="password"
                                                           onChange={this.handleChange}
                                                           name="password"
                                                           autoComplete="off"
                                                           value={this.state.emailConfiguration.password?this.state.emailConfiguration.password:''} maxLength="255" minLength="3"/>
                                                    <div style={{color:"red"}}>
                                                        {this.validator.message('password', this.state.emailConfiguration.password, 'required|max:255')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('bluConfig.label.confirm')}<RequiredAstrisk/></label>

                                                <div className="col-lg-7">
                                                    <input type="password" className="form-control" id="confirm"
                                                           onChange={this.handleChange}
                                                           name="confirm"
                                                           autoComplete="off"
                                                           maxLength="255" minLength="3"
                                                           value={this.state.emailConfiguration.confirm?this.state.emailConfiguration.confirm:''}/>
                                                    <div style={{color:"red"}}>
                                                        {this.validator.message('confirm password', this.state.emailConfiguration.confirm,
                                                            `required|in:${this.state.emailConfiguration.password}`, {messages: {in: 'Passwords need to match!'}})}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('emailConfig.label.server')}<RequiredAstrisk/></label>

                                                <div className="col-lg-7">
                                                    <input type="text" id="server" className="form-control" name="server"
                                                           value={this.state.emailConfiguration.server?this.state.emailConfiguration.server:''} maxLength="255"
                                                           onChange={_this.handleChange}/>
                                                    <div style={{color:"red"}}>
                                                        {this.validator.message('server', this.state.emailConfiguration.server, 'required|max:255')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign:'left'}}>From Address<RequiredAstrisk/></label>

                                                <div className="col-lg-7">
                                                    <input type="text" className="form-control" id="fromAddress"
                                                           name="fromAddress" onChange={this.handleChange}
                                                           value={this.state.emailConfiguration.fromAddress?this.state.emailConfiguration.fromAddress:''}
                                                           maxLength="128"/>
                                                    <div style={{color:"red"}}>
                                                        {this.validator.message('fromAddress', this.state.emailConfiguration.fromAddress, 'required|max:128|email')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('emailConfig.label.name')}</label>

                                                <div className="col-lg-7">
                                                    <input type="text" className="form-control" id="fromName"
                                                           name="fromName" onChange={this.handleChange}
                                                           value={this.state.emailConfiguration.fromName?this.state.emailConfiguration.fromName:''} maxLength="64"/>
                                                    <div style={{color:"red"}}>
                                                        {this.validator.message('fromName', this.state.emailConfiguration.fromName, 'max:64')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign:'left', whiteSpace: 'nowrap'}}>{_this.props.msg('emailConfig.label.port')}<RequiredAstrisk/></label>

                                                <div className="col-lg-7">
                                                    <input
                                                        type="text" id="port" className="form-control" name="port"
                                                        value={this.state.emailConfiguration.port?this.state.emailConfiguration.port:''}
                                                        onChange={_this.handleChange}/>
                                                    <div style={{color:"red"}}>
                                                        {this.validator.message('port', this.state.emailConfiguration.port, 'required')}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('emailConfig.label.ccTo')}</label>

                                                <div className="col-lg-7">
                                                    <input
                                                        type="text" id="ccTo" className="form-control" name="ccTo" placeholder="Enter comma separated emails"
                                                        value={this.state.emailConfiguration.ccTo?this.state.emailConfiguration.ccTo:''}
                                                        onChange={_this.handleChange}/>
                                                    <div style={{color:"red"}}>
                                                        {this.validator.message('ccTo', this.state.emailConfiguration.ccTo, 'max:128')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign:'left', whiteSpace: 'nowrap'}}>{_this.props.msg('emailConfig.label.replyTo')}</label>

                                                <div className="col-lg-7">
                                                    <input
                                                        type="text" id="replyTo" className="form-control" name="replyTo" placeholder="Enter comma separated emails"
                                                        value={this.state.emailConfiguration.replyTo ? this.state.emailConfiguration.replyTo : ''}
                                                        onChange={_this.handleChange}/>
                                                    <div style={{color:"red"}}>
                                                        {this.validator.message('Replyto', this.state.emailConfiguration.replyTo, 'max:128')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('emailConfig.label.bcc')}</label>

                                                <div className="col-lg-7">
                                                    <input
                                                        type="text" id="bccTo" className="form-control" name="bccTo" placeholder="Enter comma separated emails"
                                                        value={this.state.emailConfiguration.bccTo ? this.state.emailConfiguration.bccTo : ''}
                                                        onChange={_this.handleChange}/>
                                                    <div style={{color:"red"}}>
                                                        {this.validator.message('bccTo', this.state.emailConfiguration.bccTo, 'max:128')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign:'left', whiteSpace: 'nowrap'}}>{_this.props.msg('emailConfig.label.disable')}</label>

                                                <div className="col-lg-1">
                                                    <input
                                                        type="checkbox" id="disableAllEmails" name="disableAllEmails"
                                                        checked={_this.state.emailConfiguration.disableAllEmails}
                                                        onChange={(e)=>_this.checkBoxChange(_this.state.emailConfiguration.disableAllEmails, 'disableAllEmails')}/>
                                                </div>
                                            </div>
                                        </div>

                                    </div>



                                    <div className="col-md-12">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="col-lg-2 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('emailConfig.label.smpt')}</label>

                                                <div className="col-lg-9">
                                                    <input type="text" id="properties" className="form-control" name="properties"
                                                           onChange={_this.handleChange} value={this.state.emailConfiguration.properties}  maxLength="200" />
                                                    {/*<div style={{color:"red"}}>
                                                        {this.validator.message('smtp properties', this.state.emailConfiguration.properties, 'required')}
                                                    </div>*/}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/*<div className="col-md-12">
                                        <div className="col-md-12">
                                            <div className="form-group" style={{color:"blue",fontWeight:"bold"}}>
                                                <p>{_this.props.msg('emailConfig.label.reminderEmailDescription')}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="col-lg-2 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('emailConfig.label.emailReminder1')}</label>

                                                <div className="col-lg-2">
                                                    <input type="number" id="reminderDays1" className="form-control" name="reminderDays1"
                                                           onChange={_this.handleChange} value={this.state.emailConfiguration.reminderDays1} placeholder="Enter days late"/>
                                                </div>
                                                <label className="col-lg-2 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('emailConfig.label.emailReminder2')}</label>

                                                <div className="col-lg-2">
                                                    <input type="number" id="reminderDays2" className="form-control" name="reminderDays2"
                                                           onChange={_this.handleChange} value={this.state.emailConfiguration.reminderDays2} placeholder="Enter days late"/>
                                                </div>


                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="col-lg-2 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('emailConfig.label.emailReminder3')}</label>

                                                <div className="col-lg-2">
                                                    <input type="number" id="reminderDays3" className="form-control" name="reminderDays3"
                                                           onChange={_this.handleChange} value={this.state.emailConfiguration.reminderDays3} placeholder="Enter days late"/>
                                                </div>
                                                <label className="col-lg-2 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('emailConfig.label.emailReminder4')}</label>

                                                <div className="col-lg-2">
                                                    <input type="number" id="reminderDays4" className="form-control" name="reminderDays4"
                                                           onChange={_this.handleChange} value={this.state.emailConfiguration.reminderDays4} placeholder="Enter days late"/>
                                                </div>

                                                <label className="col-lg-2 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('emailConfig.label.emailReminder5')}</label>

                                                <div className="col-lg-2">
                                                    <input type="number" id="reminderDays5" className="form-control" name="reminderDays5"
                                                           onChange={_this.handleChange} value={this.state.emailConfiguration.reminderDays5} placeholder="Enter days late"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
*/}

                                    <div className="form-group">
                                        <div className="col-lg-offset-2 col-lg-10">
                                            <Link to="/" className="btn btn-white" style = {{marginLeft: '18px'}}>{_this.props.msg('form.label.cancelButton')}</Link>&nbsp;&nbsp;&nbsp;
                                            <input className="btn btn-primary" type="submit" value={_this.props.msg('form.label.submit')}
                                                   disabled={this.state.disabledButton===true}/> &nbsp;&nbsp;
                                            <a className="btn btn-primary" onClick={this.sendTestEmail}
                                               disabled={this.state.disabledButton===true}>{_this.props.msg('emailConfig.label.testemail')}</a>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default EmailConf;


// WEBPACK FOOTER //
// ./src/components/organization/EmailConf.js